/**
 * 抽象类
 */
// tslint:disable:trailing-comma

export default abstract class BaseChannel {
  // 模块可用标识
  available: boolean = false;

  /**
   *  上报
   * @param params 数据
   */
  abstract send(params: any): void;
}
